import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerService, ToastConfigService, UtilityService } from '@services';
import { TisSupportService } from './tis-support.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { IMaskDirective } from 'angular-imask';
import { BrandTypePipe } from '../../shared/pipes/brand-type.pipe';

@Component({
    selector: 'app-tis-support',
    templateUrl: './tis-support.component.html',
    styleUrls: ['./tis-support.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        IMaskDirective,
        NgStyle,
        BrandTypePipe,
    ],
})
export class TisSupportComponent implements OnInit {

  public model: any; // FIXME no usage found
  
  public phoneMask = {mask: '(000) 000-0000'};

  public screenWidth: number;

  prefixList = [
    'Mr.',
    'Ms.',
    'Miss.',
    'Mrs.',
    'Jr.',
    'Sr.'
  ];

  states = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming'
  ];

  public errorMessage = '';

  public userForm = new UntypedFormGroup({});
  public fullName = new UntypedFormControl('', Validators.required);
  public companyName = new UntypedFormControl('');
  public address1 = new UntypedFormControl('', Validators.required);
  public address2 = new UntypedFormControl('');
  public city = new UntypedFormControl('', Validators.required);
  public state = new UntypedFormControl('', Validators.required);
  public zipCode = new UntypedFormControl('', Validators.required);
  public phone = new UntypedFormControl('');
  public email = new UntypedFormControl('', [Validators.required, Validators.email]);
  public comments = new UntypedFormControl('', Validators.required);
  public subject = new UntypedFormControl('', Validators.required);
  public prefix = new UntypedFormControl('');

  constructor(
    private utilityService: UtilityService,
    private fb: UntypedFormBuilder,
    private tisSupportService: TisSupportService,
    private toastService: ToastConfigService,
    private spinnerService: SpinnerService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
   }

  ngOnInit() {
    this.userForm = this.fb.group({
      fullName: this.fullName,
      company: this.companyName,
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      state: this.state,
      phoneNumber: this.phone,
      zipCode: this.zipCode,
      email: this.email,
      prefix: this.prefix,
      subject: this.subject,
      comments: this.comments
    });
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  onSubmit() {
    this.spinnerService.show('bmwSpinner');
    this.tisSupportService.sendTISSupportForm(this.userForm.value).subscribe(
      data => {
        this.spinnerService.hide('bmwSpinner');
        this.toastService.popToast('Form Submitted');
        this.errorMessage = '';
        this.userForm.reset();
      },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = error.error.message || error.message;
      }
    );
  }

}
